// extracted by mini-css-extract-plugin
export default {"ColumnChart":"apex-column-chart_ColumnChart__6Sywp"};